import { FunctionComponent } from 'react'

import { Grid } from '@material-ui/core'

import {
  MdClose,
  MdKeyboardArrowRight,
  MdErrorOutline,
  MdCheckCircleOutline,
} from 'react-icons/md'
import CustomModal from './CustomModal'
import { HorizontalLine } from '../styles'
import {
  IconMessage,
  Paragraph,
  TextRequisito,
  Title,
  ErrorMessage,
  WarningMessage,
  CloseButton,
  Requisitos,
  ArrowButton,
} from './styles'
import { colors } from 'shared/styles/colors'
import { useHistory } from 'react-router-dom'

export enum ERequisitosViagem {
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  OK = 'OK',
}

interface TProps {
  openModalRequisitos: boolean
  setOpenModalRequisitos: (value: boolean) => void
  requisitosViagem: any
}
const ModalRequisitosViagem: FunctionComponent<TProps> = ({
  openModalRequisitos,
  setOpenModalRequisitos,
  requisitosViagem,
}) => {
  const retornoEndpoint = requisitosViagem
  const history = useHistory()

  const resultValidationIcon = (respostaValidacao: any) => {
    return (
      <>
        {respostaValidacao?.value === ERequisitosViagem.ERROR && (
          <MdErrorOutline color={colors.red2} />
        )}

        {respostaValidacao?.value === ERequisitosViagem.WARNING && (
          <MdErrorOutline color={colors.yellow} />
        )}

        {respostaValidacao?.value === ERequisitosViagem.OK && (
          <MdCheckCircleOutline color={colors.green} />
        )}
      </>
    )
  }

  const resultValidationMessage = (resultadoValidacao: any) => {
    return (
      <>
        {resultadoValidacao?.value === ERequisitosViagem.ERROR && (
          <ErrorMessage>{resultadoValidacao.message}</ErrorMessage>
        )}
        {resultadoValidacao?.value === ERequisitosViagem.WARNING && (
          <WarningMessage>{resultadoValidacao.message}</WarningMessage>
        )}
      </>
    )
  }

  return (
    <CustomModal
      openModal={openModalRequisitos}
      showCloseButton={false}
      onCloseModal={() => setOpenModalRequisitos(false)}
    >
      <Grid container>
        <Grid item lg={10} md={10} sm={10}>
          <Title>Se interessou pelo frete?</Title>
        </Grid>
        <Grid item lg={2}>
          <CloseButton onClick={() => setOpenModalRequisitos(false)}>
            <MdClose size={30} />
          </CloseButton>
        </Grid>

        <Grid item lg={12}>
          <Paragraph>
            Para deixar a plataforma Tmov Frotista segura e garantir que esse
            frete seja seu, é necessário finalizar a configuração da sua conta.
          </Paragraph>
        </Grid>

        <Grid item lg={12} md={12} sm={12}>
          <Requisitos>Requisitos necessários:</Requisitos>
        </Grid>
      </Grid>
      <HorizontalLine />

      <Grid container>
        <Grid item md={1}>
          <IconMessage>
            {resultValidationIcon(retornoEndpoint?.motorista)}
          </IconMessage>
        </Grid>

        <Grid item md={10}>
          <TextRequisito>Cadastrar motorista</TextRequisito>
          {resultValidationMessage(retornoEndpoint?.motorista)}
        </Grid>

        <Grid item md={1}>
          <ArrowButton onClick={() => history.push('/motoristas/new')}>
            <MdKeyboardArrowRight color={colors.gray} size={30} />
          </ArrowButton>
        </Grid>
      </Grid>
      <HorizontalLine />

      <Grid container>
        <Grid item md={1}>
          <IconMessage>
            {resultValidationIcon(retornoEndpoint?.veiculo)}
          </IconMessage>
        </Grid>

        <Grid item md={10}>
          <TextRequisito>Cadastrar veículo</TextRequisito>
          {resultValidationMessage(retornoEndpoint?.veiculo)}
        </Grid>
        <Grid item md={1}>
          <ArrowButton onClick={() => history.push('/veiculos/adicionar')}>
            <MdKeyboardArrowRight color={colors.gray} size={30} />
          </ArrowButton>
        </Grid>
      </Grid>
      <HorizontalLine />

      <Grid container>
        <Grid item md={1}>
          <IconMessage>
            {resultValidationIcon(retornoEndpoint?.caminhao)}
          </IconMessage>
        </Grid>

        <Grid item md={10}>
          <TextRequisito>Cadastrar caminhão</TextRequisito>
          {resultValidationMessage(retornoEndpoint?.caminhao)}
        </Grid>
        <Grid item md={1}>
          <ArrowButton onClick={() => history.push('/caminhoes/register')}>
            <MdKeyboardArrowRight color={colors.gray} size={30} />
          </ArrowButton>
        </Grid>
      </Grid>
      <HorizontalLine />

      <Grid container>
        <Grid item md={1}>
          <IconMessage>
            {resultValidationIcon(retornoEndpoint?.tmovPay)}
          </IconMessage>
        </Grid>

        <Grid item md={10}>
          <TextRequisito>Criar conta TMOV PAY</TextRequisito>
          {resultValidationMessage(retornoEndpoint?.tmovPay)}
        </Grid>
        <Grid item md={1}>
          <ArrowButton onClick={() => history.push('/tmov-pay-instructions')}>
            <MdKeyboardArrowRight color={colors.gray} size={30} />
          </ArrowButton>
        </Grid>
        <HorizontalLine />
      </Grid>
    </CustomModal>
  )
}

export default ModalRequisitosViagem
